/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    DialogContent,
    DialogContentText,
    Typography,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Button,
} from '@material-ui/core';
import { isEmpty } from '../../../../utils/object';
import LinkOpenChat from '../../../../common/LinkOpenChat'

const ReplacementOrderV2Screens = ({ classes, reloadPage, text1, text2, text3, radioList, handleSelectValue,
    handleClickProceed, currentPage, nextPage, previousPage, handleClickBack, btnType, handleSubmit,
    handleOpenChat, currentSelectedRadio, isLoading, handleChangeModalState,
    replaceResponse, refundResponse, partialRefundResponse, getCurrentPage, ROSSOrderNumber,  page0ReasonType, page1ReasonType, page2ReasonType, page3ReasonType, page4ReasonType, page5ReasonType, operatingSystem, abcGbmChatPayload, isShowingMobileChatLink }) => {

        useEffect(() => {
            getCurrentPage(currentPage, nextPage);
        }, [currentPage, nextPage]);

        return (
            <>
                <DialogContent className={classes.modalContentContainer}>
                        <div className={classes.modalInnerContent}>
                            <DialogContentText>
                                {text1 && <div className={classes.modalBodyText}>{text1}</div>}
                                {text2 && <div className={classes.modalBodyText}>{text2}</div>}
                                {text3 && <div className={classes.modalBodyText}>{text3}</div>}
                            </DialogContentText>
                            <FormControl>
                                <RadioGroup onChange={handleSelectValue} defaultValue={`${currentPage}ReasonType:${currentSelectedRadio}`}>
                                    {radioList?.map((radio) => (
                                        <FormControlLabel value={`${currentPage}ReasonType:${radio}`} control={<Radio color="primary" />} label={<Typography className={classes.radioButtonsPage1}>{radio}</Typography>} />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>
                        <div className={classes.buttonsWrapper}>
                            {btnType === 'Close'
                                ? (
                                    <Button
                                        className={`${classes.cancelButton} ${classes.singleCancel}`}
                                        type="button"
                                        onClick={!isEmpty(replaceResponse) || !isEmpty(refundResponse) || !isEmpty(partialRefundResponse) ? () => reloadPage() : () => handleChangeModalState('replacement', 'closeWindow', true)}
                                    >
                                        Close
                                    </Button>
                                )
                                : (
                                    <>
                                        {currentPage !== 'page0' &&
                                            <Button
                                                className={classes.cancelButton}
                                                type="button"
                                                onClick={() => handleClickBack(currentPage, previousPage, `${currentPage}ReasonType`)}
                                            >
                                                Go back
                                            </Button>
                                        }
                                        <Button
                                            className={currentPage === 'page0' ? `${classes.CTAButton} ${classes.singleCTA}` : classes.CTAButton}
                                            type="button"
                                            onClick={() => {
                                                if (btnType === 'Chat with agent') handleOpenChat();
                                                if (btnType === 'Submit' ? handleSubmit(currentPage) : handleClickProceed(currentPage, nextPage));
                                            }}
                                            disabled={(!currentSelectedRadio && btnType !== 'Continue') || isLoading}
                                        >
                                            {isShowingMobileChatLink && btnType === 'Chat with agent' ? <LinkOpenChat customClass={classes.mobileLink} userData={abcGbmChatPayload}>{btnType}</LinkOpenChat> : (btnType || 'Next')}
                                        </Button>
                                    </>
                                )
                            }
                        </div>
                    </DialogContent>
            </>
        )
    }

export default ReplacementOrderV2Screens;
